import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18n from "i18n";
import { AIModelProvider } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { MODEL_PROVIDER_CONFIG_QUERY_KEY } from "ai-management/hooks/useModelProviderConfig";
import { emptyAuthFor } from "ai-management/providerAuth";
const useModelProviderMutations = () => {
  const queryClient = useQueryClient();
  const toCredentialsArg = (credentials) => {
    var _a;
    return {
      provider: credentials.provider,
      auth: (_a = credentials.auth) != null ? _a : emptyAuthFor(credentials.provider)
    };
  };
  const toSaveArg = (config) => {
    var _a;
    return {
      providers: config.providers.map(toCredentialsArg),
      default_provider: config.default_provider,
      default_model_id: (_a = config.default_model_id) != null ? _a : ""
    };
  };
  const save = useMutation({
    mutationFn: (config) => AIModelProvider.saveConfig(toSaveArg(config)),
    onSuccess: () => {
      UserNotification.success(i18n.t("notifications.model_provider_configuration_saved", { ns: "enterprise_ai" }));
      queryClient.invalidateQueries({ queryKey: MODEL_PROVIDER_CONFIG_QUERY_KEY });
    },
    onError: (error) => UserNotification.error(
      i18n.t("notifications.saving_configuration_failed", { ns: "enterprise_ai", error: String(error) })
    )
  });
  const test = useMutation({
    mutationFn: (body) => AIModelProvider.test({
      provider: body.provider,
      model_id: body.model_id,
      credentials: toCredentialsArg(body.credentials)
    })
  });
  const remove = useMutation({
    mutationFn: () => AIModelProvider.deleteConfig(),
    onSuccess: () => {
      UserNotification.success(i18n.t("notifications.model_provider_configuration_deleted", { ns: "enterprise_ai" }));
      queryClient.invalidateQueries({ queryKey: MODEL_PROVIDER_CONFIG_QUERY_KEY });
    },
    onError: (error) => UserNotification.error(
      i18n.t("notifications.deleting_configuration_failed", { ns: "enterprise_ai", error: String(error) })
    )
  });
  return { save, test, remove };
};
export default useModelProviderMutations;
